export default "__VITE_ASSET__1056827d__"